import { regenerateKeywordItemsFromSources } from './keywords-inherit';

export default class KeywordsSave {
  static _parseModuleSettings(target) {
    if (!target || !target.hasAttribute('data-module-settings')) {
      return null;
    }

    try {
      return JSON.parse(target.getAttribute('data-module-settings'));
    } catch (error) {
      console.warn('KeywordsSave: Invalid data-module-settings JSON', error);
      return null;
    }
  }

  static _regenerateItemsFromInheritance(target) {
    const settings = KeywordsSave._parseModuleSettings(target);

    if (!settings || !settings.inherit || !Array.isArray(settings.inherit.from)) {
      return;
    }

    regenerateKeywordItemsFromSources({
      target,
      sourceIds: settings.inherit.from,
      itemsContainerClassName: 'keywords-items-container',
    });
  }

  // Extract current state of keywords
  static getData(target) {
    const keywordsId = target.id;
    const keywordsType = target.getAttribute('data-keywords');
    const $items = target.querySelectorAll('.keywords-item');

    const items = Array.from($items).map(($item) => {
      const itemData = {
        id: $item.id,
      };

      // Different data for different keyword types
      switch (keywordsType) {
        case 'wordcloud':
          // Save the level (data-keywords-item attribute)
          itemData.level = parseInt($item.getAttribute('data-keywords-item') || '0', 10);
          break;

        case 'selekce+':
        case 'selekce-':
          // Save whether item is selected (inverse of disabled class)
          itemData.selected = !$item.classList.contains('disabled');
          break;

        default:
          break;
      }

      return itemData;
    });

    return {
      id: keywordsId,
      type: keywordsType,
      items,
    };
  }

  // Restore keywords state from saved data
  static loadData(target, data) {
    if (!data || !data.items) {
      console.warn('KeywordsSave: No valid data to load');
      return;
    }

    // In read-only mode inherited keyword groups may start with empty tagy,
    // so materialize inherited items before restoring saved state.
    if (target.querySelectorAll('.keywords-item').length === 0) {
      KeywordsSave._regenerateItemsFromInheritance(target);
    }

    const $items = target.querySelectorAll('.keywords-item');

    // Create a map of items by ID for quick lookup
    const itemsMap = new Map();
    $items.forEach(($item) => {
      itemsMap.set($item.id, $item);
    });

    // Restore each item's state
    data.items.forEach((itemData) => {
      const $item = itemsMap.get(itemData.id);
      if (!$item) return;

      switch (data.type) {
        case 'wordcloud':
          // Restore the level
          if (itemData.level !== undefined) {
            $item.setAttribute('data-keywords-item', itemData.level);
          }
          break;

        case 'selekce+':
        case 'selekce-':
          // Restore selected state (inverse of disabled class)
          if (itemData.selected !== undefined) {
            if (itemData.selected) {
              $item.classList.remove('disabled');
            } else {
              $item.classList.add('disabled');
            }
          }
          break;

        default:
          break;
      }
    });
  }
}
